
import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator'
import Widget from '@/components/Widget/Widget.vue'
import ViewModel from '@/models/ViewModel'
import IconAction from '@/components/IconAction/IconAction.vue'
import DataTable from '@/components/DataTable/index.vue'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import moment from 'moment'
import CreativeImportModule from '@/models/CreativeImportModule'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import WebMessage from '@/models/WebMessage'
import tableFields from './creative-import-table-fields'

@Component({
  components: {
    Widget,
    IconAction,
    DataTable,
    SearchInput,
  },
})
export default class CreativeImportHome extends ViewModel {
  @Ref() readonly dataTable!: HTMLFormElement

  public query: string[] = []

  public page_size: number = 25

  public page: number = 1

  public records: number = 0

  public loading: boolean = false

  public ready: boolean = false

  public fields: any = []

  public fieldFilters: any = {}

  public selectedRows: any[] = []

  public loaded_data: any[] = []

  public get show_fields() {
    return this.fields.filter((f: any) => f.show)
  }

  public filter_mode: string = 'exclusive'

  @Watch('filter_mode')
  public onFilterModeChange() {
    this.refresh()
  }

  public query_settings: any = {
    company_fields: [
      {
        name: 'advertiser',
        key: 'advertiser_id',
      },
    ],
  }

  public refresh() {
    this.dataTable.refresh()
  }

  public created() {
    this.fields = [...tableFields]
  }

  public mounted() {
    this.loadFilters()
  }

  public resetFilters() {
    Vue.set(this, 'fieldFilters', {
      type: '',
      adserver: '',
      review_status: '',
      review_source: '',
    })

    this.query = ['adserver:cim']
    this.filter_mode = 'exclusive'
    this.clearFilters()
    this.dataTable.refresh()
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'creative-import',
      data: { query: this.query, fieldFilters: this.fieldFilters, mode: this.filter_mode },
    })
  }

  public loadFilters() {
    const system = getModule(SystemtModule)
    system.getFilter('creative-import').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
        this.filter_mode = filter.mode
      }
      this.ready = true
    })
  }

  public clearFilters() {
    const system = getModule(SystemtModule)
    this.filter_mode = 'exclusive'
    system.updateState({
      name: 'filters',
      type: 'creative-import',
      data: null,
    })
  }

  public async creatives(context: any) {
    this.loading = true
    const field_filters = Object.keys(this.fieldFilters)
      .filter((key: string) => this.fieldFilters[key] !== '')
      .map((key: string) => `${key}:${this.fieldFilters[key].toLowerCase()}`)
    this.syncFilters()
    return CreativeImportModule.paginate({
      page_size: context.perPage,
      page: context.currentPage,
      order_by: context.sortBy,
      order: context.sortDesc ? 'desc' : 'asc',
      query: [...context.filter, ...field_filters],
      mode: this.filter_mode,
    }).then(result => {
      this.records = result.records
      this.loading = false
      this.loaded_data = result.data
      return result.data
    })
  }

  public statusVariant(status: string): string {
    switch (status) {
      case 'completed':
        return 'success'
      case 'failed':
        return 'danger'
      default:
        return 'secondary'
    }
  }

  public statusTooltip(item: any): string {
    return item.status === 'failed' && item.last_error ? item.last_error : ''
  }

  public async retry() {
    const items = this.loaded_data.filter(
      (item: any) => this.selectedRows.includes(item.id) && item.imported_at === null,
    )
    const item_ids = items.map((item: any) => item.id)
    await CreativeImportModule.retry(item_ids).then((response: any) => {
      if ([200, 201].includes(response.status)) {
        WebMessage.success('Retry initiated')
        this.selectedRows = []
        this.refresh()
      }
    })
  }
}
